import { Swiper } from "swiper";
import type { SwiperOptions } from "swiper/types";
import { Autoplay, Pagination, Scrollbar, Navigation } from "swiper/modules";

export default class ProductFeaturesSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const $el = this as HTMLElement;

    // Prevent double initialization
    if ($el.classList.contains("swiper-initialized")) return;

    const $elPrev = $el.querySelector<HTMLElement>(".swiper-button-prev");
    const $elNext = $el.querySelector<HTMLElement>(".swiper-button-next");

    // swiper options
    const swiperParams: SwiperOptions = {
      modules: [Navigation],
      slidesPerView: 1.81,
      spaceBetween: 16,
      centeredSlides: false,
      loop: false,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      breakpoints: {
        768: {
          slidesPerView: 3,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
        }
      },
    };

    // navigation settings
    if ($elPrev && $elNext) {
      swiperParams.navigation = {
        nextEl: $elNext,
        prevEl: $elPrev,
      };
    }

    // swiper init
    new Swiper($el, swiperParams);
  }
}
